var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUserIdCard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#fxsiwtbiga)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.25 10c0-1.151-.849-2-2-2-1.15 0-2 .849-2 2s.848 2 2 2c1.151 0 2-.849 2-2zm2.285-1v2h4V9h-4zm1 4v2h3v-2h-3zm-1.57 3h-7.43c0-1.374 1.676-3.25 3.715-3.25 2.04 0 3.715 1.876 3.715 3.25zm6.57-12h-16c-1.103 0-2 .841-2 1.875v12.25c0 1.034.897 1.875 2 1.875h16c1.103 0 2-.841 2-1.875V5.875c0-1.034-.897-1.875-2-1.875zm0 14-16-.011V6l16 .011V18z",
    fill: "#0E1D31"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUserIdCard);
export default __webpack_public_path__ + "static/media/user-id-card.12d961be.svg";
export { ForwardRef as ReactComponent };